import styled from 'styled-components';

export const Flex = styled.div<{
  justify?: string;
  align?: string;
  direction?: string;
  gap?: string;
  padding?: string;
  width?: string;
  center?: boolean;
}>`
  display: flex;
  justify-content: ${props => props.center ? 'center' : props.justify || 'flex-start'};
  align-items: ${props => props.center ? 'center' : props.align || 'stretch'};
  flex-direction: ${props => props.direction || 'row'};
  gap: ${props => props.gap || '0'};
  padding: ${props => props.padding || '0'};
  width: ${props => props.width || 'auto'};
`;
